import React from 'react';
import { connect } from 'react-redux';
import styles from './Note.module.css';
import { LoadingIcon, PatientDot } from '_components';
import { PatientCareCenterNoteContraindications } from './Contraindications';
import { PatientCareCenterNoteMiniSchedule } from './MiniSchedule';
import { PatientCareCenterNoteGoalProgress } from './GoalProgress';
import { PatientCareCenterNoteNav } from './NoteNav';
import { PatientCareCenterNoteContent } from './NoteContent';
import { PatientCareCenterNoteValidation } from './Validation';
import { PatientCareCenterNoteWpGoalProgress } from '../Note/WorkProgram';


class PatientCareCenterNote extends React.Component {

    render() {
        const subjectiveRef = React.createRef();
        const objectiveRef = React.createRef();
        const outcomesRef = React.createRef();
        const alRef = React.createRef();
        const goalsRef = React.createRef();
        const assessmentRef = React.createRef();
        const planRef = React.createRef();
        const chargesRef = React.createRef();

        if (this.props.loading) {
            return (
                <div className={styles.loading_div}>
                    <br />
                    <label>Loading...</label>
                    <br /><br />
                    <LoadingIcon size='large' />
                </div>
            );
        } else {
            return (
                <div className={styles.wrapper}>
                    <script type="application/json" id="noteMetadata">
                        {JSON.stringify(this.props.noteMetadata)}
                    </script>
                    <div className={styles.left_col}>
                        <div className={styles.patient_header}>
                            <PatientDot id={this.props.patient.dot} className={styles.patient_dot} />
                            <span className={this.props.isFederal ? styles.federal_patient_name : styles.patient_name}>
                                {this.props.patient.firstName + ' ' + this.props.patient.lastName}
                            </span>
                        </div>
                        <PatientCareCenterNoteContraindications />
                        <PatientCareCenterNoteMiniSchedule />
                        {this.props.isWp ? <PatientCareCenterNoteWpGoalProgress /> : <PatientCareCenterNoteGoalProgress />}
                    </div>
                    <div className={styles.right_col}>
                        <PatientCareCenterNoteNav
                            subjectiveRef={subjectiveRef}
                            objectiveRef={objectiveRef}
                            alRef={alRef}
                            goalsRef={goalsRef}
                            assessmentRef={assessmentRef}
                            planRef={planRef}
                            chargesRef={chargesRef}
                        />
                        <PatientCareCenterNoteContent
                            subjectiveRef={subjectiveRef}
                            objectiveRef={objectiveRef}
                            outcomesRef={outcomesRef}
                            alRef={alRef}
                            goalsRef={goalsRef}
                            assessmentRef={assessmentRef}
                            planRef={planRef}
                            chargesRef={chargesRef}
                        />
                        <PatientCareCenterNoteValidation />
                    </div>
                </div>
            );
        }
    }

}

function mapStateToProps(state) {

    let selectedTab = state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab;
    let noteId = state.ui.patientTabs[selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk]?.EVEPNO : state.entities.notes.PTNOTE[pk]?.NTEPNO;
    let isFederal = state.entities.admissions[epno]?.isFederal;
    let isWp = state.entities.admissions[epno]?.isWP;


    let noteMetadata = state.entities.notes.NOTEMETADATA[noteId];

    return {
        patient: state.entities.patients[state.ui.patients.selectedPtno],
        loading: state.ui.notes[noteId] ? state.ui.notes[noteId].loading : true,
        isFederal,
        isWp,
        noteMetadata
    };
}

const connectedPatientCareCenterNote = connect(mapStateToProps)(PatientCareCenterNote);
export { connectedPatientCareCenterNote as PatientCareCenterNote };

